{
  "endTime": "Sluttid",
  "startTime": "Starttid",
  "time": "Tid"
}
